import axios from 'axios';

axios.defaults.timeout = 120000;

// request interceptor
axios.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// response interceptor
axios.interceptors.response.use(
    response => response,
    error => {
        return Promise.reject(error);
    }
);

/**
 * @method ajax
 * @param  {Object} parameter
 * @return {Object}
 * @example
 *     ajax({
 *         url: '/xx/xx/xx',
 *         method: 'get', // 默认为 'get'
 *         params: {    // 当 GET请求时 的时候参数放在 params,当 POST 请求时 参数放在 data
 *             userId: 123
 *         },
 *         timeout: 5000
 *         ......
 *     });
 * @public
 */
export default function ajax(parameter) {
    return new Promise((resolve, reject) => {
        axios(parameter).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        });
    });
}